import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { CalendarItem } from '../../models/calendar.model';
import { Observable } from 'rxjs/Observable';
import { MessageService } from 'primeng/api';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class CalendarService {

  calendars: CalendarItem[] = [];
  calendarEditing: CalendarItem = null;

  private baseUrl = HttpClientService.BASE_MS_COMMON + '/calendar-item';
  private cachedFields: Observable<any>;

  constructor(
    private h: HttpClientService,
    private messageService: MessageService
  ) { }

  getAll(): Observable<CalendarItem[]> {
    return this.h.get(this.baseUrl + '/')
      .map(res => {
        return this.calendars = res;
      });
  }

  get(id): Observable<CalendarItem> {
    return this.h.get(this.baseUrl + '/' + id);
  }

  delete(record) {
    return this.h.delete(this.baseUrl + '/' + record.id)
      .map(res => {
        this.calendars.splice(this.calendars.indexOf(record), 1);
        this.messageService.add({severity: 'info', summary: 'Confirmed', detail: 'Calendar deleted'});
      });
  }

  post(newData: CalendarItem) {
    return this.h.post(this.baseUrl + '/', newData)
      .map(res => {
        newData.id = res.id;
        this.calendars.push(newData);
        this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });

  }

  put(data: CalendarItem) {
    return this.h.put(this.baseUrl + '/', data)
      .map(res => {
        Object.assign(this.calendarEditing, data);
        this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/CalendarItemDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/calendar/calendar.service.ts